// src/utils/userDocId.js
export function getUserDocId(user) {
  if (!user) return "";
  const base = (user.email || user.uid || "").toLowerCase().trim();
  return base.replace(/[.@]/g, "_"); // turns "a.b@c.com" -> "a_b_c_com"
}
